// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./TermsAndConditions.css";

// const TermsAndConditions = () => {
//   const [agreed, setAgreed] = useState(false);
//   const navigate = useNavigate();

//   const handleNext = () => {
//     if (agreed) {
//       navigate("/subscription-overview"); // 👈 next page route
//     }
//   };

//   return (
//     <div className="tc-page">
//       {/* HEADER */}
//       <div className="tc-header">
//         <h1>TERMS & CONDITIONS</h1>
//         <p>Please read carefully before proceeding</p>
//       </div>

//       {/* CONTENT */}
//       <div className="tc-card">
//         <Section title="1. ACCEPTANCE OF TERMS">
//           By accessing or using this platform, you agree to comply with these
//           Terms & Conditions. If you do not agree, please discontinue use.
//         </Section>

//         <Section title="2. SUBSCRIPTION & USAGE">
//           Subscription plans are billed as selected. Any misuse of services
//           may result in suspension or termination.
//         </Section>

//         <Section title="3. DATA & DOCUMENTS">
//           All information and documents provided must be accurate and valid.
//           The company reserves the right to verify submitted data.
//         </Section>

//         <Section title="4. LIMITATION OF LIABILITY">
//           The platform shall not be liable for any indirect or consequential
//           damages arising from service usage.
//         </Section>

//         {/* AGREEMENT */}
//         <div className="tc-agree">
//           <input
//             type="checkbox"
//             id="agree"
//             checked={agreed}
//             onChange={(e) => setAgreed(e.target.checked)}
//           />
//           <label htmlFor="agree">
//             I agree to the <strong>Terms and Conditions</strong>
//           </label>
//         </div>

//         {/* ACTION */}
//         <div className="tc-actions">
//           <button
//             className={`next-btn ${agreed ? "active" : ""}`}
//             disabled={!agreed}
//             onClick={handleNext}
//           >
//             NEXT
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// const Section = ({ title, children }) => (
//   <div className="tc-section">
//     <h3>{title}</h3>
//     <p>{children}</p>
//   </div>
// );

// export default TermsAndConditions;


import React, { useState } from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = ({ onNext }) => { // <-- receive onNext prop
  const [agreed, setAgreed] = useState(false);

  const handleNext = () => {
    if (agreed && onNext) {
      onNext(); // <-- call Company to switch tab
    }
  };

  return (
    <div className="tc-page">
      {/* HEADER */}
      <div className="tc-header">
        <h1>TERMS & CONDITIONS</h1>
        <p>Please read carefully before proceeding</p>
      </div>

      {/* CONTENT */}
      <div className="tc-card">
        <Section title="1. ACCEPTANCE OF TERMS">
          By accessing or using this platform, you agree to comply with these
          Terms & Conditions. If you do not agree, please discontinue use.
        </Section>

        <Section title="2. SUBSCRIPTION & USAGE">
          Subscription plans are billed as selected. Any misuse of services
          may result in suspension or termination.
        </Section>

        <Section title="3. DATA & DOCUMENTS">
          All information and documents provided must be accurate and valid.
          The company reserves the right to verify submitted data.
        </Section>

        <Section title="4. LIMITATION OF LIABILITY">
          The platform shall not be liable for any indirect or consequential
          damages arising from service usage.
        </Section>

        {/* AGREEMENT */}
        <div className="tc-agree">
          <input
            type="checkbox"
            id="agree"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <label htmlFor="agree">
            I agree to the <strong>Terms and Conditions</strong>
          </label>
        </div>

        {/* ACTION */}
        <div className="tc-actions">
          <button
            className={`next-btn ${agreed ? "active" : ""}`}
            disabled={!agreed}
            onClick={handleNext}
          >
            NEXT
          </button>
        </div>
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div className="tc-section">
    <h3>{title}</h3>
    <p>{children}</p>
  </div>
);

export default TermsAndConditions;

